import React, { useEffect, useState } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { TabView, TabPanel } from "primereact/tabview";
import { FilterMatchMode } from 'primereact/api';
import { useNavigate } from "react-router-dom";
import CommonConfig from "../../../utils/constant";
import Loader from "../../Shared/Loader/Loader";
import APIConstant from "../../../utils/pathConstants";
import api from "../../../utils/apiClient";
import moment from "moment";
import { useCatchResponse } from '../../../utils/useCatchResponse';
import { Dropdown } from "primereact/dropdown";


const CoScholasticGrading = () => {
    const { catchResponse } = useCatchResponse();
    const [searchTerm, setSearchTerm] = useState("");
    const [activeTab, setActiveTab] = useState(0);
    const navigate = useNavigate();
    const [rows, setRows] = useState(10);
    const [first, setFirst] = useState(0);
    const [globalFilterValue, setGlobalFilterValue] = useState('');
    const [coScholasticOnGoingGradesList, setCoScholasticOnGoingGradesList] = useState([]);
    const [coScholasticCompletedGradesList, setCoScholasticCompletedGradesList] = useState([]);
    const [pageAccess, setPageAccess] = useState({});
    const [filters, setFilters] = useState({
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        ClassName: { value: null, matchMode: FilterMatchMode.CONTAINS },
    });
    const [selectedYear, setSelectedYear] = useState('');
    const onPageChange = (e) => {
        setFirst(e.first);
        setRows(e.rows);
    };
    const filteredExams = (activeTab === 1 ? coScholasticCompletedGradesList : coScholasticOnGoingGradesList).filter(exam =>
        exam?.ClassName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        exam?.TermName?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
        exam?.CoScholasticName?.toLowerCase()?.includes(searchTerm?.toLowerCase())
    );

    useEffect(() => {
        const loginData = CommonConfig.loginData();
        const accessData = CommonConfig.getUserAccess('Co-Scholastic Grading');
        setPageAccess(accessData);
        getFinancialYearData(loginData);
    }, []);

    const getFinancialYearData = async (loginData) => {
        const years = await CommonConfig.getFinancialYears(loginData?._id);
        const currentYear = CommonConfig.getCurrentFinancialYear(years);
        const selectedAcYear = CommonConfig.getCookie('selectedAcademicYear');
        setSelectedYear(selectedAcYear ?? currentYear?.value);
        await GetCoScholasticGradeList(CommonConfig.isOrgOwner(loginData?.UserRole) ? loginData?._id : loginData?.CreatedBy, loginData?.CreatedBy, selectedAcYear ?? currentYear?.value);
    }

    const onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let _filters = { ...filters };
        _filters['global'].value = value;

        setFilters(_filters);
        setGlobalFilterValue(value);
    };

    const dateBodyTemplate = (rows, type) => {
        return (
            <div>{moment(rows[type]).format("DD-MM-YYYY")}</div>
        );
    };

    const GetCoScholasticGradeList = async (id, schId, financialId) => {
        try {
            let data = {
                UserID: id,
                SchoolId: schId,
                FinancialYearId: financialId
            }
            Loader.show();
            await api.post(APIConstant.path.GetCoScholasticGradesList, data).then(async response => {
                let res = response;
                if (res.success) {
                    var onGoingList = res?.data.filter(x => x?.IsAllow === true);
                    var completeList = res?.data.filter(x => x?.IsAllow === false);
                    setCoScholasticOnGoingGradesList(onGoingList);
                    setCoScholasticCompletedGradesList(completeList);
                    Loader.hide();
                }
            }).catch(err => {
                Loader.hide();
                console.log(err);
                catchResponse(err);
            });
        } catch (err) {
            Loader.hide();
            console.log(err);
            catchResponse(err);
        }
    }

    const actionTemplate = (rowData) => (
        <div className="p-d-flex p-ai-center" style={{ gap: "5px" }}>
            {(pageAccess?.AddAccess && rowData?.IsAllow) &&
                <Button icon="pi pi-star" tooltip="Grade" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/co-scholastic-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, coScholasticTemplateId: rowData?.CoScholasticTemplateId, isAllow: rowData?.IsAllow, isEdit: true, financialId: selectedYear } })} />
            }
            {(pageAccess?.ViewAccess && !rowData?.IsAllow) &&
                <Button icon="pi pi-eye" tooltip="View" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/co-scholastic-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, coScholasticTemplateId: rowData?.CoScholasticTemplateId, isAllow: rowData?.IsAllow, isEdit: false, financialId: selectedYear } })} />
            }
            {(!rowData?.IsAllow && pageAccess?.OtherAccess) && <Button icon="pi pi-pencil" tooltip="Edit" tooltipOptions={{ position: 'top' }} className="e-sction-btn p-m-0" onClick={(e) => navigate('/co-scholastic-entry', { state: { className: rowData?.ClassName, classId: rowData?.ClassId, coScholasticTemplateId: rowData?.CoScholasticTemplateId, isAllow: rowData?.IsAllow, isEdit: true, financialId: selectedYear } })} />}
        </div>
    );

    const srNoBodyTemplate = (data, props) => {
        return props?.rowIndex + 1;
    };

    const coScholasticNameTemplate = (rowData) => {
        const maxLength = 80;
        const name = rowData?.CoScholasticName || '';
        const isTruncated = name.length > maxLength;
        return (
            <span title={isTruncated ? name : ''} style={{ cursor: 'pointer' }}>
                {isTruncated ? `${name.substring(0, maxLength)}...` : name}
            </span>
        );
    };

    return (
        <div className='wayment-owner-dashboard et-master-page'>
            <div className="heading-area p-d-flex p-ai-center p-jc-between">
                <div className="p-d-flex p-ai-baseline">
                    <i className="pi pi-file-edit"></i>
                    <h2>Co-Scholastic Grading</h2>
                </div>
                <div className="e-tab-main p-ml-2 p-d-flex p-jc-center p-ai-center" style={{ flex: 1, height: 'auto', flexDirection: 'row', display: 'flex' }}>
                    <ul className="p-tabview-nav" style={{ margin: 0, padding: 0, border: 'none', background: 'none' }}>
                        <li className={activeTab === 0 ? "p-highlight" : ""} onClick={() => setActiveTab(0)}>
                            <a className="p-tabview-nav-link" style={{ cursor: 'pointer', backgroundColor: activeTab === 0 ? '#4e8ba5' : '', color: activeTab === 0 ? '#FFFFFF' : '' }}>
                                <span className="p-tabview-title" style={{ color: activeTab === 0 ? '#FFFFFF' : '' }}>Ongoing</span>
                            </a>
                        </li>
                        <li className={activeTab === 1 ? "p-highlight" : ""} onClick={() => setActiveTab(1)}>
                            <a className="p-tabview-nav-link" style={{ cursor: 'pointer', backgroundColor: activeTab === 1 ? '#4e8ba5' : '', color: activeTab === 1 ? '#FFFFFF' : '' }}>
                                <span className="p-tabview-title" style={{ color: activeTab === 1 ? '#FFFFFF' : '' }}>Completed</span>
                            </a>
                        </li>
                    </ul>
                </div>
                <div className="p-d-flex p-ai-center p-jc-between">
                    <div className="searchbar-area e-searchbar-area">
                        <i className="pi pi-search" />
                        <InputText
                            value={globalFilterValue}
                            onChange={onGlobalFilterChange}
                            placeholder="Global Search"
                        />
                    </div>
                </div>
            </div>
            <>
                {activeTab === 0 && (
                    <DataTable value={filteredExams} paginator
                        rows={rows}
                        first={first}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} />
                        <Column field="ClassName" header="Class" />
                        <Column field="TermName" header="Term Name" />
                        <Column field="CoScholasticName" header="Co-Scholastic Name" body={coScholasticNameTemplate} />
                        <Column field="StartDate" header="StartDate" body={(rowData) => dateBodyTemplate(rowData, 'StartDate')} />
                        <Column field="EndDate" header="End Date" body={(rowData) => dateBodyTemplate(rowData, 'EndDate')} />
                        <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} headerStyle={{ display: 'flex', justifyContent: 'end' }} />
                    </DataTable>
                )}
                {activeTab === 1 && (
                    <DataTable value={filteredExams} paginator
                        rows={rows}
                        first={first}
                        responsiveLayout="scroll"
                        paginatorTemplate="RowsPerPageDropdown CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink JumpToPageInput"
                        rowsPerPageOptions={[5, 10, 20]}
                        currentPageReportTemplate="Showing {first}-{last} of {totalRecords} records"
                        onPage={onPageChange}
                        className='custom-table'
                        scrollHeight='calc(100vh - 120px)'
                        size='small'
                    >
                        <Column header="Sr No" body={srNoBodyTemplate} style={{ minWidth: '6rem', maxWidth: '6rem' }} />
                        <Column field="ClassName" header="Class" style={{ minWidth: '8rem', maxWidth: '8rem' }} />
                        <Column field="TermName" header="Term Name" style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column field="CoScholasticName" header="Co-Scholastic Name" body={coScholasticNameTemplate} style={{ minWidth: '12rem', maxWidth: '12rem' }} />
                        <Column header="Action" headerClassName='e-template-action' bodyClassName='e-template-action' body={actionTemplate} headerStyle={{ display: 'flex', justifyContent: 'end' }} />
                    </DataTable>
                )}
            </>
        </div>
    );
};

export default CoScholasticGrading;
